import React, { FC } from 'react';
import styled, { StyledComponentProps } from 'styled-components';

import { typographyStyles, TypographyStylesProps } from './typographyStyles';

export const headings = {
  1: {
    fontSize: '96px',
  },
  2: {
    fontSize: '80px',
  },
  3: {
    fontSize: '72px',
  },
  4: {
    fontSize: '40px',
  },
  5: {
    fontSize: '32px',
  },
};

interface InternalHeadingProps {
  variant: keyof typeof headings;
}

export interface HeadingProps
  extends StyledComponentProps<
    'h1',
    Record<string, any>,
    TypographyStylesProps & InternalHeadingProps,
    never
  > {}

export const HeadingText = styled.div<InternalHeadingProps>`
  font-family: 'Cooper';
  font-weight: 400;
  line-height: 120%;
  font-size: ${({ variant }) => headings[variant].fontSize};

  ${typographyStyles}
`;

export const Heading: FC<HeadingProps> = ({ variant, ...rest }) => (
  <HeadingText as={`h${variant}`} variant={variant} {...rest} />
);
